import has from 'lodash.has';

// Constants
import {
    TIMESHEET_TIMESHEET_ENTRIES_MANAGE_REQUESTED,
    TIMESHEET_TIMESHEET_ENTRIES_MANAGE_SUCCEEDED,
    TIMESHEET_TIMESHEET_ENTRIES_MANAGE_FAILED,
    TIMESHEET_TIMESHEET_ENTRIES_MANAGE_CANCELED,
    TIMESHEET_TIMESHEET_ENTRIES_APPROVE_REQUESTED,
    TIMESHEET_TIMESHEET_ENTRIES_APPROVE_SUCCEEDED,
    TIMESHEET_TIMESHEET_ENTRIES_APPROVE_FAILED,
    TIMESHEET_TIMESHEET_ENTRIES_SET,
    TIMESHEET_TIMESHEET_ENTRIES_MERGE,
    TIMESHEET_TIMESHEET_ENTRIES_REMOVE,
    TIMESHEET_TIMESHEET_ENTRY_SET
} from './constants';

export function requestManageTimesheetTimesheetEntries(data) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_MANAGE_REQUESTED,
        payload: {
            data
        }
    };
}

export function succeededManageTimesheetTimesheetEntries(response) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_MANAGE_SUCCEEDED,
        payload: response
    };
}

export function failedManageTimesheetTimesheetEntries(error) {
    const hasErrors = has(error, 'response.data.errors');
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_MANAGE_FAILED,
        payload: error,
        error: true,
        meta: {
            // If the error response has errors, assume that these errors were expected and log as a warning
            logentries: hasErrors ? 'warning' : 'error'
        }
    };
}

export function canceledManageTimesheetTimesheetEntries() {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_MANAGE_CANCELED,
        payload: {}
    };
}

export function requestApproveTimesheetTimesheetEntries(timesheetEntryUuids) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_APPROVE_REQUESTED,
        payload: {
            timesheetEntryUuids
        }
    };
}

export function succeededApproveTimesheetTimesheetEntries(response) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_APPROVE_SUCCEEDED,
        payload: response
    };
}

export function failedApproveTimesheetTimesheetEntries(error) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_APPROVE_FAILED,
        payload: error,
        error: true
    };
}

export function setTimesheetTimesheetEntries(data) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_SET,
        payload: data
    };
}

export function mergeTimesheetTimesheetEntries(data) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_MERGE,
        payload: data
    };
}

export function removeTimesheetTimesheetEntries(timesheetEntryUuids) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRIES_REMOVE,
        payload: {
            timesheetEntryUuids
        }
    };
}

export function setTimesheetTimesheetEntry(data) {
    return {
        type: TIMESHEET_TIMESHEET_ENTRY_SET,
        payload: data
    };
}
